import React from "react";
import { string } from "prop-types";
import { Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";

function DetailMenuComponent(props) {
  const { menuName, isActive } = props;
  return (
    <Row onClick={props.onClick} className={css(styles.menuRow)}>
      <span
        className={css(
          styles.menuName,
          isActive === true && styles.menuNameActive
        )}
      >
        {menuName}
      </span>
    </Row>
  );
}

DetailMenuComponent.propTypes = {
  menuName: string,
};

const styles = StyleSheet.create({
  menuName: {
    textAlign: "left",
    fontSize: 16,
    color: "#495057",
    ":hover": {
      cursor: "pointer",
    },
  },
  menuNameActive: {
    color: "#2CB96A",
  },
  menuRow: {
    borderBottom: "2px solid #EDEDEE",
    padding: "20px 0px",
    width: "100%",
  },
});

export default DetailMenuComponent;
